import { Link as Scroll } from 'react-scroll'

import { MiyawakaNav, Main } from './style'
import TopicItem from './topicItem'
import { SectionTitle } from '@/components/elements/SectionTitle'
import { Spacer } from '@/components/elements/Spacer'

import type { RemoteProps } from '@/types/remoteworktown'

export const Detailed = ({ topics }: RemoteProps) => {
  return (
    <div>
      <MiyawakaNav className="miyawaka-nav">
        <img src="/images/remoteworktown_kv.png" alt="" />
        <div className="miyawaka-nav__desc">
          福岡市と北九州市のほぼ中間に位置する宮若市。この地で、新しいまちづくりが始まっています。このページでは、市民・行政・民間事業者が協働して開設する国内初のリテールAI開発拠点「リモートワークタウンムスブ宮若」の構想や進捗等についてお知らせしていきます。
        </div>
        <ul className="miyawaka-nav__list">
          <li className="miyawaka-nav__list-item">
            <Scroll
              to="news"
              smooth={true}
              offset={-120}
              className="miyawaka-nav__list-item-link"
            >
              News
            </Scroll>
          </li>
          <li className="miyawaka-nav__list-item">
            <Scroll
              to="concept"
              smooth={true}
              offset={-120}
              className="miyawaka-nav__list-item-link"
            >
              施設紹介
            </Scroll>
          </li>
          <li className="miyawaka-nav__list-item">
            <Scroll
              to="links"
              smooth={true}
              offset={-120}
              className="miyawaka-nav__list-item-link"
            >
              各種リンク
            </Scroll>
          </li>
        </ul>
      </MiyawakaNav>
      <Main>
        <div className="miyawaka-intro">
          <div className="miyawaka-intro__movie-block">
            <div className="miyawaka-intro__movie-item">
              <div>
                <iframe
                  className="miyawaka-intro__movie"
                  src="https://www.youtube.com/embed/nHqTUbf_MXM"
                  title="YouTube video player"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                />
              </div>
              <h2 className="miyawaka-intro__movie-title">
                <strong>次世代型スマートストアTRIALGO</strong>
              </h2>
            </div>
          </div>
        </div>
        {topics?.length ? (
          <div id="news" className="miyawaka-news">
            <SectionTitle titleText="News" color="normal" />
            <ul className="miyawaka-news__list">
              {topics?.map((topic, index) => {
                return <TopicItem key={index} topic={topic} />
              })}
            </ul>
          </div>
        ) : (
          ''
        )}
        <div id="concept" className="miyawaka-concept">
          <SectionTitle titleText="施設紹介" color="normal" />
          <Spacer h={{ sp: 40, pc: 70 }} />
          <section className="miyawaka-concept__block">
            <div className="miyawaka-concept__block-title-wrapper">
              <img
                src="/images/remoteworktown_icon.png"
                alt="リモートワークタウン"
                className="miyawaka-concept__icon"
              />
              <h3 className="miyawaka-concept__block-title">
                リテールAI開発拠点
                <span className="miyawaka-concept__block-title-sub">
                  ～世界中から研究者・技術者が集まる場へ〜
                </span>
              </h3>
            </div>
            <div className="miyawaka-three-column">
              <div className="miyawaka-three-column__item">
                <img
                  className="miyawaka-three-column__img"
                  src="/images/remoteworktown_iotlob.png"
                  alt="TRIAL IoT Lab"
                />
                <h3 className="miyawaka-three-column__title">TRIAL IoT Lab</h3>
                <p className="miyawaka-three-column__text">
                  旧宮田西中学校の校舎をリノベーション。最先端のIoT技術の開発、高度化を図る場所として、デバイス開発センターの機能を備えています。今後はトライアルとお取引のあるメーカーのエンジニアメンバーも招聘し、スマートショッピングカートをはじめ、リテールの技術革新を進めて流通革命を起こす拠点となっていきます。
                </p>
              </div>
              <div className="miyawaka-three-column__item">
                <img
                  className="miyawaka-three-column__img"
                  src="/images/remoteworktown_musubuai.JPG"
                  alt="TRIAL MUSUBU AI"
                />
                <h3 className="miyawaka-three-column__title">MUSUBU AI</h3>
                <p className="miyawaka-three-column__text">
                  旧吉川小学校の校舎をリノベーション。AI研究開発者が自由かつ快適に研究開発に打ち込める環境を整えました。また、サテライトオフィスやプロジェクトルームを備えることで日本中のみならず世界中と繋ぎ、距離による障壁をなくしております。首都圏と世界を繋ぐ、技術開発の強力な地場となっています。今後は“知のオープン化”、教育機関と連携した将来の種撒きを行う施設として活用いたします。
                </p>
              </div>
              <div className="miyawaka-three-column__item">
                <img
                  className="miyawaka-three-column__img"
                  src="/images/remoteworktown_mediabase.jpg"
                  alt="TRIAL MEDIA BASE"
                />
                <h3 className="miyawaka-three-column__title">MEDIA BASE</h3>
                <p className="miyawaka-three-column__text">
                  旧笠松小学校の校舎をリノベーション。ショッパーマーケティング実現のため、店頭のデジタルサイネージで放映したりSNSで使用したりするコンテンツの作成や、情報発信をおこなう基地です。
                </p>
              </div>
            </div>
          </section>
          <section className="miyawaka-concept__block">
            <div className="miyawaka-concept__block-title-wrapper">
              <img
                src="/images/remoteworktown_icon.png"
                alt="リモートワークタウン"
                className="miyawaka-concept__icon"
              />
              <h3 className="miyawaka-concept__block-title">
                地域共生「食」「住」改革
              </h3>
            </div>
            <div className="miyawaka-three-column">
              <div className="miyawaka-three-column__item">
                <img
                  className="miyawaka-three-column__img"
                  src="/images/remoteworktown_groceria.JPG"
                  alt="TRIAL GROCERIA"
                />
                <h3 className="miyawaka-three-column__title">グロッサリア</h3>
                <p className="miyawaka-three-column__text-title">
                  福岡・宮若、そして九州の地域色豊かなおいしさとともに
                </p>
                <p className="miyawaka-three-column__text">
                  「グロッサリア」とは、ただ食べるだけでなく新たな食事シーンや食文化の創出につながる場を提供する、スーパーとグルメレストランを掛け合わせたトライアルの新しい複合業態です。
                  「グロッサリア」は、食品を意味する「グロッサリー」と、イタリアの大衆食堂「トラットリア」を組み合わせた造語で、食品スーパーとしてのトライアルを「食」を軸に発展させた店舗です。宮若産をはじめとする地元九州の食材を活かした地産地消料理を提供し、ミシュラン星付き高級フレンチで働いたシェフや東京で素材にこだわった超人気ベーカリーの元ディレクター等、一流料理人が監修しています。
                </p>
              </div>
              <div className="miyawaka-three-column__item">
                <img
                  className="miyawaka-three-column__img"
                  src="/images/remoteworktown_toranou.jpg"
                  alt="TRIAL TORANOU"
                />
                <h3 className="miyawaka-three-column__title">宮若虎の湯</h3>
                <p className="miyawaka-three-column__text-title">
                  懐かしい風景と地産地消ビュッフェでもてなす温泉旅館
                </p>
                <p className="miyawaka-three-column__text">
                  2021年12月、豊かな自然と実りの里・福岡県宮若市の「宮若温泉郷」内に誕生した温泉旅館です。のどかな風景に囲まれながら温泉とグルメで心身を癒やせる至福の宿です。夕食は、「Buffet
                  KOHAKU」にて地産地消の食事を提供しています。部屋は8タイプ全44室で、すべて温泉風呂付きの客室となっており、プライベートな陶器風呂や檜風呂で宿自慢の温泉を独占できます。
                </p>
              </div>
              <div className="miyawaka-three-column__item">
                <img
                  className="miyawaka-three-column__img"
                  src="/images/remoteworktown_neri.jpg"
                  alt="TRIAL NERI"
                />
                <h3 className="miyawaka-three-column__title">古民家「煉り」</h3>
                <p className="miyawaka-three-column__text-title">
                  “豊かな自然と実りの里”に佇む全6棟の離れの宿
                </p>
                <p className="miyawaka-three-column__text">
                  温泉付きの古民家の離れを独り占めする温泉宿で、2021年7月にオープンしました。旅館文化を次の世代へとつなげてきた先人への感謝と敬意を忘れず、一日一日、ゲストを大切に出迎え、“第二の故郷”となるよう、温かく細やかな心遣いでもてなすのが「古民家 煉り」の信条です。
                  <br />
                  古民家の温泉付きの離れで、止まる時間、さかのぼるひととき、思い出す心の居心地を感受し、大切な人と慕わしい憩いに浸ることができます。
                </p>
              </div>
            </div>
            <div className="miyawaka-three-column">
              <div className="miyawaka-three-column__item">
                <img
                  className="miyawaka-three-column__img"
                  src="/images/remoteworktown_kohaku.jpg"
                  alt="TRIAL KOHAKU"
                />
                <h3 className="miyawaka-three-column__title">料匠虎白</h3>
                <p className="miyawaka-three-column__text-title">
                  自然と健康を考えた懐石料理を極める
                </p>
                <p className="miyawaka-three-column__text">
                  経験豊富な料理人が、地域で育った新鮮で安心の食材にこだわり、伝統を大切にしながらも今を感じる料理を提供しています。地元・福岡の風土や美味しい湧き水、盆地の寒暖差が育てた数々の野菜、近くの漁港で水揚げされた新鮮な海の幸を中心に、人が自然と笑顔になるような料理を心がけています。
                  <br />
                  昔ながらのかまどの使用など料理に合わせた調理過程にもこだわりを持っています。
                  <br />
                  同敷地内にある「古民家煉り」の宿泊者は朝食も楽しむことができます。
                </p>
              </div>
              <div className="miyawaka-three-column__item">
                <img
                  className="miyawaka-three-column__img"
                  src="/images/remoteworktown_soukatei.jpg"
                  alt="TRIAL SAUKATEI"
                />
                <h3 className="miyawaka-three-column__title">颯香亭</h3>
                <p className="miyawaka-three-column__text-title">
                  宮若、福岡そして九州風土の恩恵を滋味深い味わいへ
                </p>
                <p className="miyawaka-three-column__text">
                  「ミシュランガイド福岡2019」の1つ星に選ばれたフレンチ「颯香亭」では、生産者から直に仕入れる食材を使った“自然”がモチーフの料理を、ご要望やご予算に応じた“オートクチュール”なディナーコースで提供しています。
                  <br />
                  「颯香亭」には決まったメニューはなく、素材の声に耳を傾け、受け取ったインスピレーションを料理として具現化しています。
                </p>
              </div>
            </div>
            <div className="miyawaka-facility__img">
              <img src="/images/remoteworktown_map.png" alt="宮若市全域図" />
            </div>
            <div className="facility-table-wrapper">
              <p className="facility-table-scroll-hint">
                ※横スクロールできます
              </p>
              <table className="facility-table" cellSpacing="0">
                <thead>
                  <tr>
                    <th className="facility-table__head">これまで</th>
                    <th className="facility-table__head">これから</th>
                    <th className="facility-table__head">稼働開始時期</th>
                  </tr>
                </thead>
                <tbody>
                  <tr className="facility-table__row">
                    <td className="facility-table__number1">
                      旧 吉川小学校校舎
                    </td>
                    <td className="facility-table__data">
                      MUSUBU AI
                      <br />
                      <span className="facility-table__data--small">
                        （AI開発センター）
                      </span>
                    </td>
                    <td className="facility-table__data">2021年6月</td>
                  </tr>
                  <tr className="facility-table__row">
                    <td className="facility-table__number2">
                      旧 吉川小学校体育館
                    </td>
                    <td className="facility-table__data">
                      グロッサリア
                      <br />
                      <span className="facility-table__data--small">
                        （農園レストラン）
                      </span>
                    </td>
                    <td className="facility-table__data">2022年4月</td>
                  </tr>
                  <tr className="facility-table__row">
                    <td className="facility-table__number3">
                      旧 吉川小学校運動場
                    </td>
                    <td className="facility-table__data">
                      TRIAL GO脇田店
                      <br />
                      in みやわかの郷
                    </td>
                    <td className="facility-table__data">2022年4月</td>
                  </tr>
                  <tr className="facility-table__row">
                    <td className="facility-table__number4" rowSpan={4}>
                      旧 スコーレ若宮
                    </td>
                    <td className="facility-table__data">
                      宮若虎の湯
                      <br />
                      <span className="facility-table__data--small">
                        （MUSUBU宮若温泉郷）
                      </span>
                    </td>
                    <td className="facility-table__data">2021年12月</td>
                  </tr>
                  <tr className="facility-table__row">
                    <td className="facility-table__data">
                      古民家 煉り
                      <br />
                      <span className="facility-table__data--small">
                        （MUSUBU宮若温泉郷）
                      </span>
                    </td>
                    <td className="facility-table__data">2021年7月</td>
                  </tr>
                  <tr className="facility-table__row">
                    <td className="facility-table__data">
                      颯香亭
                      <br />
                      <span className="facility-table__data--small">
                        （MUSUBU宮若温泉郷）
                      </span>
                    </td>
                    <td className="facility-table__data">2021年7月</td>
                  </tr>
                  <tr className="facility-table__row">
                    <td className="facility-table__data">
                      料匠虎白
                      <br />
                      <span className="facility-table__data--small">
                        （MUSUBU宮若温泉郷）
                      </span>
                    </td>
                    <td className="facility-table__data">2021年7月</td>
                  </tr>
                  <tr className="facility-table__row">
                    <td className="facility-table__number5">旧 宮田西中学校</td>
                    <td className="facility-table__data">
                      TRIAL IoT Lab
                      <br />
                      <span className="facility-table__data--small">
                        （AIデバイス開発センター）
                      </span>
                    </td>
                    <td className="facility-table__data">2021年7月</td>
                  </tr>
                  <tr className="facility-table__row">
                    <td className="facility-table__number6">旧 笠松小学校</td>
                    <td className="facility-table__data">
                      MEDIA BASE
                      <br />
                      <span className="facility-table__data--small">
                        (スマートストアの
                        <br />
                        メディアコンテンツ作成)
                      </span>
                    </td>
                    <td className="facility-table__data">2021年7月</td>
                  </tr>
                  <tr className="facility-table__row">
                    <td className="facility-table__number7">
                      旧 宮田
                      <br />
                      ショッピングセンター
                    </td>
                    <td className="facility-table__data">
                      スーパーセンター
                      <br />
                      トライアル宮田店
                    </td>
                    <td className="facility-table__data">2021年10月</td>
                  </tr>
                </tbody>
                <tfoot>
                  <tr>
                    <th className="facility-table__foot">これまで</th>
                    <th className="facility-table__foot">これから</th>
                    <th className="facility-table__foot">稼働開始時期</th>
                  </tr>
                </tfoot>
              </table>
            </div>
          </section>
        </div>
        <section id="links" className="miyawaka-links">
          <SectionTitle titleText="各種リンク" color="normal" />
          <div className="miyawaka-links__main">
            <div className="miyawaka-links__link-item">
              <a
                href="https://www.city.miyawaka.lg.jp/"
                target="_blank"
                rel="noreferrer noopener"
                className="miyawaka-links__img-link"
              >
                <img
                  src="/images/remoteworktown_miyawaka_logo.png"
                  alt="宮若市"
                  className="miyawaka-links__img"
                />
              </a>
              <a
                href="https://www.city.miyawaka.lg.jp/"
                target="_blank"
                rel="noreferrer noopener"
                className="miyawaka-links__link"
              >
                宮若市
              </a>
            </div>
            <div className="miyawaka-links__link-item">
              <a
                href="https://www.kyushu-u.ac.jp/ja/"
                target="_blank"
                rel="noreferrer noopener"
                className="miyawaka-links__img-link"
              >
                <img
                  src="/images/remoteworktown_kyusyu_university_logo.png"
                  alt="九州大学"
                  className="miyawaka-links__img"
                />
              </a>
              <a
                href="https://www.kyushu-u.ac.jp/ja/"
                target="_blank"
                rel="noreferrer noopener"
                className="miyawaka-links__link"
              >
                九州大学
              </a>
            </div>
          </div>
          <section className="miyawaka-links__group">
            <h3 className="miyawaka-links__group-title">宿泊・飲食施設関連</h3>
            <ul className="miyawaka-links__group-link-list">
              <li className="miyawaka-links__group-link-item">
                <a
                  href="https://groceria.jp/"
                  target="_blank"
                  rel="noreferrer noopener"
                  className="miyawaka-links__group-link"
                >
                  グロッサリア
                </a>
              </li>
              <li className="miyawaka-links__group-link-item">
                <a
                  href="https://miyawaka-toranoyu.com/"
                  target="_blank"
                  rel="noreferrer noopener"
                  className="miyawaka-links__group-link"
                >
                  宮若虎の湯
                </a>
              </li>
              <li className="miyawaka-links__group-link-item">
                <a
                  href="https://kominka-neri.com/"
                  target="_blank"
                  rel="noreferrer noopener"
                  className="miyawaka-links__group-link"
                >
                  古民家 煉り
                </a>
              </li>

              <li className="miyawaka-links__group-link-item">
                <a
                  href="https://ryosho-kohaku.com/"
                  target="_blank"
                  rel="noreferrer noopener"
                  className="miyawaka-links__group-link"
                >
                  料匠 虎白
                </a>
              </li>
              <li className="miyawaka-links__group-link-item">
                <a
                  href="https://info-soukatei.com/"
                  target="_blank"
                  rel="noreferrer noopener"
                  className="miyawaka-links__group-link"
                >
                  颯香亭
                </a>
              </li>
              <li className="miyawaka-links__group-link-item">
                <a
                  href="https://miyawaka-onsenkyo.com/"
                  target="_blank"
                  rel="noreferrer noopener"
                  className="miyawaka-links__group-link"
                >
                  宮若温泉郷
                </a>
              </li>
            </ul>
          </section>
        </section>
        <div className="miyawaka-conclusion">
          <div className="miyawaka-conclusion__img">
            <img
              src="/images/remoteworktown_msg2.png"
              alt="変えるなら、世界ごと。トライアルグループ"
            />
          </div>
        </div>
      </Main>
    </div>
  )
}
